module.exports = __webpack_public_path__ + "static/img/mini2.1c65dcd9.png";